import apiClient from '@u/apiClient'
import GetSupplierListController from '@/wayfinder/actions/App/Http/Controllers/Supplier/GetSupplierListController'
import GetSupplierByIdController from '@/wayfinder/actions/App/Http/Controllers/Supplier/GetSupplierByIdController'
import FetchItemsBySupplierByIdController from '@/wayfinder/actions/App/Http/Controllers/Supplier/FetchItemsBySupplierByIdController'
import GetSupplierActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Supplier/GetSupplierActivitiesByIdController'
import CreateSupplierController from '@/wayfinder/actions/App/Http/Controllers/Supplier/CreateSupplierController'
import UpdateSupplierController from '@/wayfinder/actions/App/Http/Controllers/Supplier/UpdateSupplierController'
import DeleteSupplierController from '@/wayfinder/actions/App/Http/Controllers/Supplier/DeleteSupplierController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
let base_errors = { deceased: {}, events: [] }
function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

// Cache de dédoublonnage en dehors du state Vuex plutôt que dans state.js :
// il ne représente aucune donnée du domaine (juste "un fetch est en cours"),
// et vivre dans le state forcerait à passer par une mutation pour chaque
// écriture/effacement rien que pour ce contrôle de concurrence interne à
// cette action. Reste correct tant qu'une seule instance du store existe par
// page (cas de cette app) — évite les appels dupliqués si plusieurs
// composants demandent la liste fournisseurs au même moment.
let fetchSupplierListPromise = null

export default {
  //region fetch
  fetchSupplierList({ commit }) {
    if (fetchSupplierListPromise) {
      return fetchSupplierListPromise
    }
    fetchSupplierListPromise = apiClient
      .route(GetSupplierListController.get())
      .then((response) => {
        if (response.status === 200) {
          commit('setSupplierList', response.data.suppliers)
          commit('setMetadata', response.data.metadata)
        }
      })
      .catch((reason) => {
        console.error('fetchSupplierList', reason)
      })
      .finally(() => {
        fetchSupplierListPromise = null
      })
    return fetchSupplierListPromise
  },
  fetchSupplierById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSupplierByIdController.get({ supplier: payload.supplier_id }))
        .then((response) => {
          if (response.status === 200) {
            commit('setSupplier', response.data.supplier)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewSupplier({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'supplier' } }))
        .then((response) => {
          if (response.status === 200) {
            commit('setSupplier', response.data.supplier)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchSupplierItemsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemsBySupplierByIdController.get({
            supplier: payload.supplier_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchSupplierActivitiesBySupplierID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetSupplierActivitiesByIdController.get({
            supplier: payload.supplier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchSupplierHistory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/supplier/${payload.supplier_id}/history/${payload.type}`, {
          params: payload.params,
          signal: payload.signal
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  //region store
  storeSupplier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateSupplierController.post(), payload.supplier)
        .then((response) => {
          if (response.status === 201) {
            commit('setSupplier', response.data.supplier)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  //region update
  updateSupplier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateSupplierController.put({ supplier: payload.supplier_id }),
          payload.supplier
        )
        .then((response) => {
          commit('setSupplier', response.data.supplier)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  // region delete
  deleteSupplierById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteSupplierController.delete.delete({ supplier: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteSupplierById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteSupplierController.undo.get({ id: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
